import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var FlagUa = createSvg(React.createElement(React.Fragment, null,
    React.createElement("g", { fill: "none" },
        React.createElement("path", { fill: "#FFD500", d: "M0 0h299.418v300H0z" }),
        React.createElement("path", { fill: "#005BBB", d: "M0 0h299.418v150H0z" }))), '0 0 300 300', 'FlagUa');
//# sourceMappingURL=FlagUa.js.map